/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const COMMUNICATIONPROGRAM_SUCCESS = 'COMMUNICATIONPROGRAM_SUCCESS';
export const COMMUNICATIONPROGRAM_BEGIN = 'COMMUNICATIONPROGRAM_BEGIN';
export const COMMUNICATIONPROGRAM_FAILURE = 'COMMUNICATIONPROGRAM_FAILURE';
export const CLEAR_COMMUNICATIONPROGRAM = 'CLEAR_COMMUNICATIONPROGRAM';

export const COMMUNICATIONPROGRAM_DIFFUSION_SUCCESS = 'COMMUNICATIONPROGRAM_DIFFUSION_SUCCESS';
export const COMMUNICATIONPROGRAM_DIFFUSION_BEGIN = 'COMMUNICATIONPROGRAM_DIFFUSION_BEGIN';
export const COMMUNICATIONPROGRAM_DIFFUSION_FAILURE = 'COMMUNICATIONPROGRAM_DIFFUSION_FAILURE';
export const COMMUNICATIONPROGRAM_DIFFUSION_CLEAR = 'COMMUNICATIONPROGRAM_DIFFUSION_CLEAR';

export const COMMUNICATIONPROGRAM_FILTER_SUCCESS = 'COMMUNICATIONPROGRAM_FILTER_SUCCESS';
export const COMMUNICATIONPROGRAM_FILTER_BEGIN = 'COMMUNICATIONPROGRAM_FILTER_BEGIN';
export const COMMUNICATIONPROGRAM_FILTER_FAILURE = 'COMMUNICATIONPROGRAM_FILTER_FAILURE';
export const COMMUNICATIONPROGRAM_FILTER_CLEAR = 'COMMUNICATIONPROGRAM_FILTER_CLEAR';

export const COMMUNICATIONPROGRAM_COURSE_SUCCESS = 'COMMUNICATIONPROGRAM_COURSE_SUCCESS';
export const COMMUNICATIONPROGRAM_COURSE_BEGIN = 'COMMUNICATIONPROGRAM_COURSE_BEGIN';
export const COMMUNICATIONPROGRAM_COURSE_FAILURE = 'COMMUNICATIONPROGRAM_COURSE_FAILURE';
export const COMMUNICATIONPROGRAM_COURSE_CLEAR = 'COMMUNICATIONPROGRAM_COURSE_CLEAR';

export const COMMUNICATIONPROGRAM_COURSEAVAILABLE_SUCCESS = 'COMMUNICATIONPROGRAM_COURSEAVAILABLE_SUCCESS';
export const COMMUNICATIONPROGRAM_COURSEAVAILABLE_BEGIN = 'COMMUNICATIONPROGRAM_COURSEAVAILABLE_BEGIN';
export const COMMUNICATIONPROGRAM_COURSEAVAILABLE_FAILURE = 'COMMUNICATIONPROGRAM_COURSEAVAILABLE_FAILURE';
export const COMMUNICATIONPROGRAM_COURSEAVAILABLE_CLEAR = 'COMMUNICATIONPROGRAM_COURSEAVAILABLE_CLEAR';

export const COMMUNICATION_DISPATCH_FILTER_BEGIN = 'COMMUNICATION_DISPATCH_FILTER_BEGIN';
export const COMMUNICATION_DISPATCH_FILTER_SUCCESS = 'COMMUNICATION_DISPATCH_FILTER_SUCCESS';
export const COMMUNICATION_DISPATCH_FILTER_FAILURE = 'COMMUNICATION_DISPATCH_FILTER_FAILURE';
export const COMMUNICATION_DISPATCH_FILTER_CLEAR = 'COMMUNICATION_DISPATCH_FILTER_CLEAR';

export const COMMUNICATION_PROGRAM_SUMMARY_SUCCESS = 'COMMUNICATION_PROGRAM_SUMMARY_SUCCESS';
export const COMMUNICATION_PROGRAM_SUMMARY_BEGIN = 'COMMUNICATION_PROGRAM_SUMMARY_BEGIN';
export const COMMUNICATION_PROGRAM_SUMMARY_FAILURE = 'COMMUNICATION_PROGRAM_SUMMARY_FAILURE';
export const CLEAR_COMMUNICATION_PROGRAM_SUMMARY = 'CLEAR_COMMUNICATION_PROGRAM_SUMMARY';

export const COMMUNICATION_PROGRAM_SUMMARY_FILTERS_SUCCESS = 'COMMUNICATION_PROGRAM_SUMMARY_FILTERS_SUCCESS';
export const COMMUNICATION_PROGRAM_SUMMARY_FILTERS_BEGIN = 'COMMUNICATION_PROGRAM_SUMMARY_FILTERS_BEGIN';
export const COMMUNICATION_PROGRAM_SUMMARY_FILTERS_FAILURE = 'COMMUNICATION_PROGRAM_SUMMARY_FILTERS_FAILURE';
export const CLEAR_COMMUNICATION_PROGRAM_SUMMARY_FILTERS = 'CLEAR_COMMUNICATION_PROGRAM_SUMMARY_FILTERS';

export const COMMUNICATION_GRAPHICS_BEGIN = 'COMMUNICATION_GRAPHICS_BEGIN';
export const COMMUNICATION_GRAPHICS_SUCCESS = 'COMMUNICATION_GRAPHICS_SUCCESS';
export const COMMUNICATION_GRAPHICS_FAILURE = 'COMMUNICATION_GRAPHICS_FAILURE';
export const CLEAR_COMMUNICATION_GRAPHICS = 'CLEAR_COMMUNICATION_GRAPHICS';

export const COMMUNICATION_PROGRAM_DETAILS_SUCCESS = 'COMMUNICATION_PROGRAM_DETAILS_SUCCESS';
export const COMMUNICATION_PROGRAM_DETAILS_BEGIN = 'COMMUNICATION_PROGRAM_DETAILS_BEGIN';
export const COMMUNICATION_PROGRAM_DETAILS_FAILURE = 'COMMUNICATION_PROGRAM_DETAILS_FAILURE';
export const CLEAR_COMMUNICATION_PROGRAM_DETAILS = 'CLEAR_COMMUNICATION_PROGRAM_DETAILS';


export const COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_REQUEST = 'COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_REQUEST';
export const COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_SUCCESS = 'COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_SUCCESS';
export const COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_FAILURE = 'COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_FAILURE';
export const CLEAR_COMMUNICATION_EXTERNAL_COLLABORATE = 'CLEAR_COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE';

export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_REQUEST = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_REQUEST';
export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_SUCCESS = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_SUCCESS';
export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_FAILURE = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_FAILURE';
export const CLEAR_COMMUNICATION_COLLABORATE_BY_CATEGORY = 'CLEAR_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY';

export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_REQUEST = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_REQUEST';
export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_SUCCESS = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_SUCCESS';
export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_FAILURE = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_FAILURE';
export const CLEAR_COMMUNICATION_COLLABORATE_BY_IDEMPLOYEE = 'CLEAR_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE';

export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_REQUEST = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_REQUEST';
export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_SUCCESS = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_SUCCESS';
export const GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_FAILURE = 'COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_FAILURE';
export const CLEAR_COMMUNICATION_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED = 'CLEAR_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED';
export const ASSIGN_EMPLOYEE_FILE = 'ASSIGN_EMPLOYEE_FILE';
export const REMOVE_EMPLOYEE_FILE = 'REMOVE_EMPLOYEE_FILE';

export const EXPORT_CA_REQUEST = 'EXPORT_CA_REQUEST';
export const EXPORT_CA_SUCCESS = 'EXPORT_CA_SUCCESS';
export const EXPORT_CA_FAILURE = 'EXPORT_CA_FAILURE';

export const EXPORT_LAYOUT_REQUEST = 'EXPORT_LAYOUT_REQUEST';
export const EXPORT_LAYOUT_SUCCESS = 'EXPORT_LAYOUT_SUCCESS';
export const EXPORT_LAYOUT_FAILURE = 'EXPORT_LAYOUT_FAILURE';

export const VALIDATE_LAYOUT_REQUEST = 'VALIDATE_LAYOUT_REQUEST';
export const VALIDATE_LAYOUT_SUCCESS = 'VALIDATE_LAYOUT_SUCCESS';
export const VALIDATE_LAYOUT_FAILURE = 'VALIDATE_LAYOUT_FAILURE';

export function fetchCommunicationProgram(params = {}) {
    return async dispatch => {
        dispatch(communicationProgramBegin());
        await ApiService.getCommunicationPrograms(params)
            .then(
                result => {
                    dispatch(addCommunicationProgram(result));
                },
                error => {
                    dispatch(communicationProgramError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchDiffusionCommunicationProgramById(data) {
    return async dispatch => {
        dispatch(comunicationProgramDiffusionClear());
        dispatch(comunicationProgramDiffusionBegin());
        await ApiService.getCommunicationProgramDiffusionbyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCommunicationProgram');
                    dispatch(comunicationProgramDiffusionAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(comunicationProgramDiffusionError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCourseCommunicationProgramById(data) {
    return async dispatch => {
        dispatch(comunicationProgramCourseClear());
        dispatch(comunicationProgramCourseBegin());
        await ApiService.getCommunicationProgramCoursebyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCommunicationProgram');
                    dispatch(comunicationProgramCourseAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(comunicationProgramCourseError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCourseAvailableCommunicationProgramById(data) {
    return async dispatch => {
        dispatch(comunicationProgramCourseAvailableClear());
        dispatch(comunicationProgramCourseAvailableBegin());
        await ApiService.getCommunicationProgramCourseAvailablebyId(data)
            .then(
                result => {
                    let normalized = normalizeById(result.Data, 'idCommunicationProgram');
                    dispatch(comunicationProgramCourseAvailableAdd(normalized));
                    return normalized;
                },
                error => {
                    dispatch(comunicationProgramCourseAvailableError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationProgramFilter(params = {}) {
    return async dispatch => {
        dispatch(communicationProgramFilterBegin());
        await ApiService.getCommunicationProgramsFilter(params)
            .then(
                result => {
                    dispatch(communicationProgramFilterAdd(result));
                },
                error => {
                    dispatch(communicationProgramFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationDispatchFilter(id) {
    return async dispatch => {
        dispatch(communicationDispatchFilterBegin());
        await ApiService.getCommunicationsDispatchFilters(id)
            .then(
                result => {
                    dispatch(communicationDispatchFilterAdd(result));
                },
                error => {
                    dispatch(communicationDispatchFilterError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationProgramSummary(params = {}) {
    return async dispatch => {
        dispatch(communicationProgramSummaryBegin());
        await ApiService.getCommunicationProgramsSummary(params)
            .then(
                result => {
                    dispatch(communicationProgramSummarySuccess(result));
                },
                error => {
                    dispatch(communicationProgramSummaryError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationProgramSummaryFilters(data) {
    return async dispatch => {
        dispatch(communicationProgramSummaryFiltersBegin());
        await ApiService.getCommunicationProgramsSummaryFilters(data)
            .then(
                result => {
                   
                    dispatch(communicationProgramSummaryFiltersSuccess(result));
                },
                error => {
                    dispatch(communicationProgramSummaryFiltersError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchGraphics(data) {
    return async dispatch => {
        dispatch(graphicsBegin());
        await ApiService.getCommunicationProgramsGraphics(data)
            .then(
                result => {
                    dispatch(graphicsSuccess(result));
                },
                error => {
                    dispatch(graphicsError());
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export function fetchCommunicationProgramDetails(params = {}, id) {
    return async dispatch => {
        dispatch(communicationProgramDetailsBegin());
        await ApiService.getCommunicationProgramsDetails(params, id)
            .then(
                result => {
                    dispatch(communicationProgramDetailsSuccess(result));
                },
                error => {
                    dispatch(communicationProgramDetailsError());
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    };
}

export const communicationProgramBegin = () => ({
    type: COMMUNICATIONPROGRAM_BEGIN,
});
export const addCommunicationProgram = data => ({
    type: COMMUNICATIONPROGRAM_SUCCESS,
    payload: { data }
})
export const communicationProgramError = () => ({
    type: COMMUNICATIONPROGRAM_FAILURE,
})
export const clearCommunicationProgram = () => ({
    type: CLEAR_COMMUNICATIONPROGRAM,
})

//Diffusion
export const comunicationProgramDiffusionBegin = () => ({
    type: COMMUNICATIONPROGRAM_DIFFUSION_BEGIN,
});
export const comunicationProgramDiffusionAdd = data => ({
    type: COMMUNICATIONPROGRAM_DIFFUSION_SUCCESS,
    payload: { data }
})
export const comunicationProgramDiffusionError = () => ({
    type: COMMUNICATIONPROGRAM_DIFFUSION_FAILURE,
})
export const comunicationProgramDiffusionClear = () => ({
    type: COMMUNICATIONPROGRAM_DIFFUSION_CLEAR,
})

//Course
export const comunicationProgramCourseBegin = () => ({
    type: COMMUNICATIONPROGRAM_COURSE_BEGIN,
});
export const comunicationProgramCourseAdd = data => ({
    type: COMMUNICATIONPROGRAM_COURSE_SUCCESS,
    payload: { data }
})
export const comunicationProgramCourseError = () => ({
    type: COMMUNICATIONPROGRAM_COURSE_FAILURE,
})
export const comunicationProgramCourseClear = () => ({
    type: COMMUNICATIONPROGRAM_COURSE_CLEAR,
})

//CourseAvailable
export const comunicationProgramCourseAvailableBegin = () => ({
    type: COMMUNICATIONPROGRAM_COURSEAVAILABLE_BEGIN,
});
export const comunicationProgramCourseAvailableAdd = data => ({
    type: COMMUNICATIONPROGRAM_COURSEAVAILABLE_SUCCESS,
    payload: { data }
})
export const comunicationProgramCourseAvailableError = () => ({
    type: COMMUNICATIONPROGRAM_COURSEAVAILABLE_FAILURE,
})
export const comunicationProgramCourseAvailableClear = () => ({
    type: COMMUNICATIONPROGRAM_COURSEAVAILABLE_CLEAR,
})

//COMMUNICATIONPROGRAM FILTERS
export const communicationProgramFilterBegin = () => ({
    type: COMMUNICATIONPROGRAM_FILTER_BEGIN,
});
export const communicationProgramFilterAdd = filterData => ({
    type: COMMUNICATIONPROGRAM_FILTER_SUCCESS,
    payload: { filterData }
})
export const communicationProgramFilterError = filterError => ({
    type: COMMUNICATIONPROGRAM_FILTER_FAILURE,
    payload: { filterError }
})
export const clearcommunicationProgramFilter = () => ({
    type: COMMUNICATIONPROGRAM_FILTER_CLEAR,
})

//COMMUNICATIONPROGRAM FILTERS
export const communicationDispatchFilterBegin = () => ({
    type: COMMUNICATION_DISPATCH_FILTER_BEGIN,
});
export const communicationDispatchFilterAdd = filterDispatch => ({
    type: COMMUNICATION_DISPATCH_FILTER_SUCCESS,
    payload: { filterDispatch }
})
export const communicationDispatchFilterError = filterDispatchError => ({
    type: COMMUNICATION_DISPATCH_FILTER_FAILURE,
    payload: { filterDispatchError }
})
export const clearcommunicationDispatchFilter = () => ({
    type: COMMUNICATION_DISPATCH_FILTER_CLEAR,
})

//CommunicationProgramSummary
export const communicationProgramSummaryBegin = () => ({
    type: COMMUNICATION_PROGRAM_SUMMARY_BEGIN,
});
export const communicationProgramSummarySuccess = data => ({
    type: COMMUNICATION_PROGRAM_SUMMARY_SUCCESS,
    payload: { data }
})
export const communicationProgramSummaryError = () => ({
    type: COMMUNICATION_PROGRAM_SUMMARY_FAILURE,
})
export const clearCommunicationProgramSummary = () => ({
    type: CLEAR_COMMUNICATION_PROGRAM_SUMMARY,
})

//CommunicationProgramSummary
export const communicationProgramSummaryFiltersBegin = () => ({
    type: COMMUNICATION_PROGRAM_SUMMARY_FILTERS_BEGIN,
});
export const communicationProgramSummaryFiltersSuccess = data => ({
    type: COMMUNICATION_PROGRAM_SUMMARY_FILTERS_SUCCESS,
    payload: { data }
})
export const communicationProgramSummaryFiltersError = () => ({
    type: COMMUNICATION_PROGRAM_SUMMARY_FILTERS_FAILURE,
})
export const clearCommunicationProgramSummaryFilters = () => ({
    type: CLEAR_COMMUNICATION_PROGRAM_SUMMARY_FILTERS,
})

//Graphs
export const graphicsBegin = () => ({
    type: COMMUNICATION_GRAPHICS_BEGIN,
});

export const graphicsSuccess = data => ({
    type: COMMUNICATION_GRAPHICS_SUCCESS,
    payload: { data }
})

export const graphicsError = () => ({
    type: COMMUNICATION_GRAPHICS_FAILURE,
})

export const clearGraphics = () => ({
    type: CLEAR_COMMUNICATION_GRAPHICS,
});

export const communicationProgramDetailsBegin = () => ({
    type: COMMUNICATION_PROGRAM_DETAILS_BEGIN,
});
export const communicationProgramDetailsSuccess = data => ({
    type: COMMUNICATION_PROGRAM_DETAILS_SUCCESS,
    payload: { data }
})
export const communicationProgramDetailsError = () => ({
    type: COMMUNICATION_PROGRAM_DETAILS_FAILURE,
})
export const clearCommunicationProgramDetails = () => ({
    type: CLEAR_COMMUNICATION_PROGRAM_DETAILS,
})

export const assignEmployeesFile = (idCourse, employees) => ({
    type: ASSIGN_EMPLOYEE_FILE,
    payload: {
        idCourse: idCourse,
        employees: employees
    }
})

export const removeEmployeesFile = (idCourse, employees) => ({
    type: REMOVE_EMPLOYEE_FILE,
    
})

/* Recuperacion de colaboradores */
export const getExternalEmployees = () => async dispatch => {
    dispatch({ type: COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_REQUEST });
    ApiService.generateToken().then(
        response => {
            ApiService.getExternalEmployee(response.access_token).then(
                resp => {
                    dispatch({
                        type: COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_SUCCESS,
                        payload: resp
                    });
                }
            ).catch((error) => {
                dispatch({ type: COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_FAILURE, payload: error.response.message });
            });

        }
    ).catch((error) => {
        dispatch({ type: COMMUNICATION_PROGRAM_EXTERNAL_COLLABORATE_FAILURE, payload: error.response.message });
    });
}

export const getEmployeesBycategory = (data) => async dispatch => {
    dispatch({ type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_REQUEST });
    ApiService.getEmployeesByCategory(data).then(
        response => {
            dispatch({
                type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_SUCCESS,
                payload: response.data
            });
        }
    ).catch((error) => {
        dispatch({ type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_CATEGORY_FAILURE, payload: error.response.message });
    });
}

export const getEmployeesByIdEmployee = (data) => async dispatch => {
    dispatch({ type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_REQUEST });
    ApiService.getEmployeesByIdEmployee(data).then(
        response => {
            dispatch({
                type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_SUCCESS,
                payload: response.data
            });
        }
    ).catch((error) => {
        dispatch({ type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_FAILURE, payload: error.response.message });
    });
}

export const getAssignedEmployeesByIdEmployee = (params = {}) => async dispatch => {
    dispatch({ type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_REQUEST });
    ApiService.getAssignedEmployeesByIdEmployee(params).then(
        response => {
            dispatch({
                type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_SUCCESS,
                payload: response.data
            });
        }
    ).catch((error) => {
        dispatch({ type: GET_COMMUNICATION_PROGRAM_COLLABORATE_BY_IDEMPLOYEE_ASSIGNED_FAILURE, payload: error.response.message });
    });
}

/* Carga por Layout*/
export const getEmployeeLayout = (name = "LayoutColaborador.xlsx") => async dispatch => {
    dispatch({ type: EXPORT_LAYOUT_REQUEST });
    ApiService.downloadLayoutEmployee(name).then(
        response => {
            dispatch({ type: EXPORT_LAYOUT_SUCCESS });
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, name);
        }
    ).catch((error) => {
        dispatch({ type: EXPORT_LAYOUT_FAILURE, payload: error.response.message });
    });
}

export const postEmployeeLayout = (IdCourse = 0, fileName = null) => async dispatch => {
    dispatch({ type: VALIDATE_LAYOUT_REQUEST });
    ApiService.validateEmployeeTemplate(IdCourse, fileName).then(
        response => {
            dispatch({ type: VALIDATE_LAYOUT_SUCCESS });
        }
    ).catch((error) => {
        dispatch({ type: VALIDATE_LAYOUT_FAILURE, payload: error.response.message });
    });
}

const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};